import { defineComponent as _defineComponent } from 'vue'
import { ListDisplay, Heading } from '@warrenbrasil/nebraska-web';

import { getCurrencyTextColor } from '@/modules/common/helpers/currency';
import { NumberFormatted } from '@/modules/trade/types';

interface Props {
  title: string;
  value: NumberFormatted;
  showTooltip?: boolean;
  tooltipLabel?: string;
}
interface Emits {
  (e: 'tooltip-click'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TextDisplay',
  props: {
    title: null,
    value: null,
    showTooltip: { type: Boolean },
    tooltipLabel: null
  },
  emits: ["tooltip-click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'tooltip-click'): void;
}), expose: any, slots: any, attrs: any }) {





const handleTooltipClick = () => {
  emit('tooltip-click');
};

return { __sfc: true,emit, handleTooltipClick, ListDisplay, Heading, getCurrencyTextColor }
}

})